import type { FaireProductEntity } from "../../entity_types/product";

export const p_xng27c3gry: FaireProductEntity = {
  token: "p_xng27c3gry",
  type: "product",
  name: "Peppermint Tallow Butter Lip Balm",
  brandToken: "b_9uwahrnma5",
  brandName: "Butterface",
  imageUrl:
    "https://cdn.faire.com/fastly/14ab13e655f63f558bfcf3dd985b1a526881b66c2f0a559e1b6d6c5551ab6ccf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63848537db48a8172a79c29dfb4ed06a2860f9772455049f60e792e20c1ebf43.jpeg",
    "https://cdn.faire.com/fastly/ca9fda3873b374d1897163695231504299e363c7f8871f78b38db97fcd48ea0f.png",
    "https://cdn.faire.com/fastly/c3211953b5b0c45bce0e42db109ea73f520e37b0e0baef21266fb48a0fe4951f.png",
    "https://cdn.faire.com/fastly/2707be5b99d322bd560bd6cc28ebc239c86d1d157754d9ee71eeaaa49396e812.jpeg",
  ],
  priceDollars: 6,
  description:
    "A tallow lip balm customers come back for.\n\nMade with regenerative grass-fed beef tallow, organic beeswax, and peppermint oil, Butterface delivers long-lasting hydration without the waxy feel of conventional lip balms. Customers regularly tell us it's the only balm they've found that keeps their lips comfortable for hours.\n\nPackaged in a plastic-free biodegradable tube and made in the USA, it's an easy add-on at checkout and a standout option for clean beauty, wellness, gift, and apothecary retailers.\n\nWhy retailers love it:\n\n• Trending tallow-based formula with a simple ingredient story\n\n• Plastic-free packaging customers notice\n\n• Strong impulse-buy price point\n\n• Keystone margin ($6 wholesale / $12 MSRP)\n\n• Compact footprint and easy merchandising\n\n• Made in the USA",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:29.263Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
